var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { getPx, IG_TAG, Inline, SylController, SylPlugin } from '@syllepsis/adapter';
import { checkMarkDisable, formatMenuValues, getFixSize, getFormatAttrsByValue, } from '../../utils';
var PLUGIN_NAME = 'letter_space';
var LetterSpace = /** @class */ (function (_super) {
    __extends(LetterSpace, _super);
    function LetterSpace(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.name = 'letter_space';
        _this.tagName = function () { return 'span'; };
        _this.formatAttrs = function (v) { return v; };
        _this.defaultFontSize = 16;
        _this.defaultValue = 0;
        _this.attrs = {
            space: {
                default: '',
            },
        };
        _this.parseDOM = [
            {
                style: 'letter-spacing',
                getAttrs: function (style) {
                    return _this.formatAttrs({
                        space: getPx(style, _this.defaultFontSize),
                    });
                },
            },
        ];
        _this.toDOM = function (node) {
            var space = node.attrs.space;
            var attrs = {};
            if (+space !== _this.defaultValue) {
                attrs.style = "letter-spacing: " + getFixSize(space) + "px;";
            }
            else {
                attrs[IG_TAG] = 'true';
            }
            return [_this.tagName(), attrs, 0];
        };
        props && _this.constructParseDOM(props);
        return _this;
    }
    LetterSpace.prototype.constructParseDOM = function (config) {
        if (!config || !config.allowedValues)
            return;
        var _a = getFormatAttrsByValue(config.allowedValues, 'space'), formatAttrs = _a.formatAttrs, defaultValue = _a.defaultValue;
        defaultValue !== undefined && (this.defaultValue = +defaultValue);
        if (config.defaultFontSize)
            this.defaultFontSize = +config.defaultFontSize;
        this.formatAttrs = formatAttrs;
    };
    return LetterSpace;
}(Inline));
var LetterSpaceController = /** @class */ (function (_super) {
    __extends(LetterSpaceController, _super);
    function LetterSpaceController(editor, props) {
        var _this = _super.call(this, editor, props) || this;
        _this.name = PLUGIN_NAME;
        _this.constructValue = function (props) {
            if (props.values) {
                _this.toolbar.value = formatMenuValues('space', props.values);
            }
        };
        _this.toolbar = {
            className: PLUGIN_NAME,
            tooltip: PLUGIN_NAME,
            type: 'dropdown',
            value: [
                {
                    attrs: false,
                    text: '0',
                },
                {
                    attrs: { space: 0.5 },
                    text: '0.5',
                },
                {
                    attrs: { space: 1 },
                    text: '1',
                },
                {
                    attrs: { space: 1.5 },
                    text: '1.5',
                },
            ],
        };
        _this.disable = function (editor) { return checkMarkDisable(editor.view, PLUGIN_NAME); };
        _this.constructValue(props);
        return _this;
    }
    return LetterSpaceController;
}(SylController));
var LetterSpacePlugin = /** @class */ (function (_super) {
    __extends(LetterSpacePlugin, _super);
    function LetterSpacePlugin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = PLUGIN_NAME;
        _this.Schema = LetterSpace;
        _this.Controller = LetterSpaceController;
        return _this;
    }
    return LetterSpacePlugin;
}(SylPlugin));
export { LetterSpace, LetterSpaceController, LetterSpacePlugin };
//# sourceMappingURL=index.js.map